import { render, staticRenderFns } from "./BenchmarkBarMetric.vue?vue&type=template&id=02ee1e4b&scoped=true&"
import script from "./BenchmarkBarMetric.vue?vue&type=script&setup=true&lang=js&"
export * from "./BenchmarkBarMetric.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BenchmarkBarMetric.vue?vue&type=style&index=0&id=02ee1e4b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ee1e4b",
  null
  
)

export default component.exports